// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"4":"64c6c48e","96":"97f1fecf","176":"99ee67e9","432":"e728aba9","496":"09dfe248","644":"f3fe1214","740":"700cf64a","800":"bc6f50ba","964":"0ce48fde"}[chunkId] + ".js";
};